export default __webpack_public_path__ + "static/media/rebel.b051cd5c.png";